import { EditorOptions } from 'tinymce';

const TinyMceQuillBaseConfig: Partial<EditorOptions> = {
  base_url: '/tinymce',
  suffix: '.min',
  promotion: false,
  statusbar: false,
  menubar: false,
  toolbar_location: 'top',
  width: '100%',
  height: '300px',
  object_resizing: false as never,
  table_resize_bars: false,
  table_sizing_mode: 'relative',
  paste_as_text: true,
  link_target_list: false,
  link_title: false,
  image_title: false,
  file_picker_types: 'image',
  image_dimensions: false,
  image_description: false,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  file_picker_callback: callback => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    // eslint-disable-next-line no-restricted-syntax
    input.addEventListener('change', () => {
      if (!input.files.length) return;
      const file = input.files.item(0);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => callback(reader.result as string, { width: '100%', height: 'auto' });
    });
    input.click();
  }
};

export const TinyMceSimpleQuillConfig: Partial<EditorOptions> = {
  ...TinyMceQuillBaseConfig,
  toolbar:
    'bold italic underline strikethrough | numlist bullist | subscript superscript | removeformat | link | blocks',
  plugins: ['lists', 'link']
};

export const TinyMceAdvancedQuillConfig: Partial<EditorOptions> = {
  ...TinyMceQuillBaseConfig,
  toolbar:
    'bold italic underline strikethrough | numlist bullist | subscript superscript | removeformat | link | blocks | outdent indent | align | image',
  plugins: ['lists', 'link', 'image']
};
